import React from 'react';

import { Box, Checkbox, Link, Typography } from '@mui/material';

import type { AssetField } from './AssetFieldGrid';

export default function AssetFieldCell({ label, value, href, checkbox }: AssetField) {
  const hasValue = value || value === 0;
  // false is a meaningful value here, so an unticked box must render instead of a dash.
  const isCheckbox = checkbox !== undefined && checkbox !== null;

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ py: 0.75, borderBottom: 1, borderColor: 'divider' }}>
        {label}
      </Typography>
      <Box sx={{ py: 0.75, borderBottom: 1, borderColor: 'divider' }}>
        {isCheckbox ? (
          <Checkbox
            checked={!!checkbox}
            disabled
            disableRipple
            size="small"
            sx={{ p: 0 }}
            // The label lives in a sibling grid cell, so it never names this input on its own.
            inputProps={{ 'aria-label': label }}
          />
        ) : hasValue && href ? (
          <Link href={href} target="_blank" rel="noopener noreferrer" variant="body2">
            {value}
          </Link>
        ) : (
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
            {hasValue ? value : '—'}
          </Typography>
        )}
      </Box>
    </>
  );
}
